import NamedDto from 'modules/base/dto/NamedDto';
import OpcDaWriterFieldEditDto from './OpcDaWriterFieldEditDto';

export class OpcDaWriterEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.hostName = null;

		/** @type {string} */
		this.serverName = null;

		/** @type {number} */
		this.opcDaWriterLog = null;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _OpcDaWriterEditDtoProps
	 * @property {string} hostName
	 * @property {string} serverName
	 * @property {number} opcDaWriterLog
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OpcDaWriterEditDtoProps} OpcDaWriterEditDtoProps
	 */
	/**
	 *
	 * @param {OpcDaWriterEditDtoProps} props
	 * @returns {OpcDaWriterEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.hostName = props.hostName;
		this.serverName = props.serverName;
		this.opcDaWriterLog = props.opcDaWriterLog;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default OpcDaWriterEditDto;
